var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.322,
    viewBox: "0 0 12 12.322",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M1.818,9.1A6.221,6.221,0,0,1,6.065,1.462l.079-.021h0A5.647,5.647,0,0,0,4.708,6.872a5.411,5.411,0,0,0,6.6,3.958,5.269,5.269,0,0,0,2-1.048,6.047,6.047,0,0,1-4.064,3.771,5.858,5.858,0,0,1-1.544.208A6.152,6.152,0,0,1,1.818,9.1Zm9.492-.853a1.779,1.779,0,0,0-1.247-.583,1.776,1.776,0,0,0,1.247-.583,1.855,1.855,0,0,0,.514-1.315,1.844,1.844,0,0,0,.518,1.312,1.787,1.787,0,0,0,1.262.585,1.8,1.8,0,0,0-1.262.583,1.838,1.838,0,0,0-.518,1.31A1.85,1.85,0,0,0,11.31,8.248Zm-1.256-.583h0ZM7.4,5.733a2.383,2.383,0,0,0-1.675-.782A2.384,2.384,0,0,0,7.4,4.171a2.449,2.449,0,0,0,.687-1.74,2.448,2.448,0,0,0,.69,1.741,2.393,2.393,0,0,0,1.677.779,2.387,2.387,0,0,0-1.193.376A2.541,2.541,0,0,0,8.086,7.481,2.465,2.465,0,0,0,7.4,5.733Z",
    transform: "translate(-1.603 -1.44)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Moon.ac648027f74b62c835ad9ba98e11d1a7.svg";